import React from "react";
import HomeMenu from "./HomeMenu";
import PropTypes from "prop-types";
import { getJwt } from "../../app/config/auth/credentialConfiguration";
import UserMenuMovil from "./UserMenuMovil";
import UserMenuDesktop from "./UserMenuDesktop";
import { Grid } from "semantic-ui-react";
import IdleMonitor from "./IdleMonitor";

const NavBar = ({ mediaStyles, Media, MediaContextProvider }) => {
  return (
    <>
      {getJwt() ? (
        <>
          <style>{mediaStyles}</style>
          <MediaContextProvider>
            <Grid>
              <Grid.Row as={Media} at="mobile">
                <UserMenuMovil />
              </Grid.Row>
              <Grid.Row as={Media} at="tablet">
                <UserMenuMovil />
              </Grid.Row>
              <Grid.Row as={Media} greaterThan="tablet">
                <UserMenuDesktop />
              </Grid.Row>
              <IdleMonitor />
            </Grid>
          </MediaContextProvider>
        </>
      ) : (
        <HomeMenu />
      )}
    </>
  );
};

NavBar.propTypes = {
  mediaStyles: PropTypes.string.isRequired,
  Media: PropTypes.func.isRequired,
  MediaContextProvider: PropTypes.func.isRequired,
};

export default NavBar;
